<!-- JobCard.vue -->
<template>
  <article class="job-card">
    <div class="job-card__img">
      <img 
        :src="displayImage" 
        :alt="title"
        @error="handleImageError"
      />
    </div>

    <h3 class="job-card__title">{{ title }}</h3>

    <p class="job-card__meta">
      <span>{{ vacancies }} vacante<span v-if="vacancies !== 1">s</span></span>
      <span class="dot">|</span>
      <span>{{ place }}</span>
    </p>

    <div class="job-card__footer">
      <button
        class="icon-btn"
        type="button"
        aria-label="Favorito"
        :disabled="!isUserLogged"
      >
        <i class="bx bx-heart"></i>
      </button>
      <button
        class="icon-btn"
        type="button"
        aria-label="Compartir"
        @click="shareJob"
      >
        <i class="bx bx-share-alt"></i>
      </button>

      <button class="apply-btn" type="button" @click="handleApply">
        Postular
      </button>
    </div>
  </article>
</template>

<script>
export default {
  name: "JobCard_AS",
  props: {
    title: {
      type: String,
      default: "Auxiliar de Cosecha",
    },
    vacancies: {
      type: Number,
      default: 3,
    },
    place: {
      type: String,
      default: "Olmos",
    },
    image: {
      type: String,
      default: "",
    },
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      imageError: false,
      // Simple gray placeholder as data URL
      placeholderImage: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23e0e0e0" width="400" height="300"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="24" x="50%25" y="50%25" text-anchor="middle" dominant-baseline="middle"%3ENo Image%3C/text%3E%3C/svg%3E'
    };
  },
  computed: {
    isUserLogged() {
      return !!localStorage.getItem("userData");
    },
    displayImage() {
      if (this.imageError || !this.image) {
        console.warn(`No image available for job: ${this.title}, using placeholder`);
        return this.placeholderImage;
      }
      return this.image;
    }
  },
  mounted() {
    console.log(`JobCard mounted - Title: ${this.title}, Image URL: ${this.image}`);
  },
  methods: {
    handleApply() {
      this.$router.push({
        path: "/detalle_oferta",
        query: { id: this.id },
      });
    },

    handleImageError(event) {
      console.error(`Failed to load image for job: ${this.title}, URL: ${this.image}`);
      this.imageError = true;
    },

    shareJob() {
      if (navigator.share) {
        navigator.share({
          title: this.title,
          text: `Revisa esta oferta de trabajo: ${this.title}`,
          url: window.location.href,
        });
      } else {
        navigator.clipboard.writeText(window.location.href);
        this.$toastr.success("Enlace copiado al portapapeles.", "Listo");
      }
    },
  },
};
</script>

<style scoped>
.job-card {
  position: relative;
  overflow: visible;
  background: #fff;
  border: 1px solid rgba(10, 30, 70, 0.15);
  border-radius: 18px;
  padding: 14px;
  padding-top: 120px;
  width: 100%;
  max-width: 260px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  display: flex;
  flex-direction: column;
}

.job-card:hover {
  border-color: var(--bg-primary-as-light);
  box-shadow: 0 8px 24px rgba(25, 87, 209, 0.12);
}

.job-card__img {
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 85%;
  height: 180px;
  border-radius: 12px;
  overflow: hidden;
  background: #f3f5f8;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.job-card__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.job-card__title {
  font-size: 16px;
  font-weight: 700;
  color: #0a1e46;
  margin: 8px 0 6px;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: calc(1.35em * 2);
}

.job-card__meta {
  margin: 0 0 12px;
  color: #6a7385;
  font-size: 13px;
  line-height: 1.3;
  min-height: 1.3em;
}
.job-card__meta .dot {
  margin: 0 3px;
}

.job-card__footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.icon-btn {
  border: 1px solid rgba(10, 30, 70, 0.12);
  background: #fff;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.icon-btn i {
  font-size: 18px;
  color: var(--bg-primary-as-light);
}

.icon-btn:hover {
  background: rgba(25, 87, 209, 0.06);
  border-color: rgba(25, 87, 209, 0.35);
}

.icon-btn:disabled,
.icon-btn[disabled] {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.apply-btn {
  margin-left: auto;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid var(--bg-primary-as-light);
  background: #fff;
  color: var(--bg-primary-as-light);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.apply-btn:hover {
  background: var(--bg-primary-as-light);
  color: #fff;
}
</style>
